import React from 'react';
import {ExpressBox} from './express/ExpressBox';
import StepsCompute from './components/StepsCompute';
import {useDispatch, useSelector} from "react-redux";
import {StoreType} from "../../../store/spirs/types";
import {REMOVE_COUPON_EVENT} from "../../../store/spirs/actions";
import {CouponEvent} from "../../../store/spirs/reducers/couponReducer";
import { ScrollContainer } from '../scrollContainer';

interface IExpressListProps {
    couponEvents: CouponEvent[];
}

export function ExpressList(props: IExpressListProps) {
    const {couponEvents} = props;
    const rate = useSelector((state: StoreType) => state.spirs.coupons.rate.EXPRESS);
    const dispatch = useDispatch();

    function removeEventFromCoupon(selectionId?: number) {
        if (!selectionId) {
            throw Error('selectionId must be number, undefined passed');
        } else {
            dispatch(REMOVE_COUPON_EVENT(selectionId));
        }
    }

    return (
        <div className="rounded-[8px] bg-[#272D33] overflow-hidden">
            { couponEvents.length ? <ScrollContainer className="overflow-y-auto max-h-[calc(100vh-510px)] notebook:max-h-[calc(100vh-583px)]">
                {couponEvents.map((event) => (
                    <div className="bg-[#272D33] overflow-hidden" key={event.selectionId}>
                        <ExpressBox
                            event={event}
                            removeEventFromCoupon={() => removeEventFromCoupon(event.selectionId)}
                            index={event.selectionId}
                        />
                    </div>
                ))}
            </ScrollContainer> : null}
            {couponEvents.length > 0 ? <StepsCompute rate={rate}/> : ''}
        </div>
    );
}
